import { Type, Validator } from "./Type";
import { SearchFieldComponent } from "../components/Inputs/SearchField/SearchFieldComponent";

interface SearchFieldOptions {
  minNumberOfLetters: number;
  placeholder?: string;
  executeSearch: (text: string) => void;
}

export const SearchField = (
  options: SearchFieldOptions,
  ...validators: Validator[]
) =>
  new Type({
    // @ts-ignore
    Component: SearchFieldComponent,
    // @ts-ignore
    PresentationComponent: SearchFieldComponent,
    props: { ...options },
    validators
  });
